document.addEventListener("DOMContentLoaded", function () {
	let timelineWidth = $(".timeline").first().width() * 2; // Double the width of the first .timeline element
	let gap = 75;

	// Check screen width and adjust gap value
	if (window.innerWidth < 1500) {
		gap = 100;
	}

	$(".timeline").each(function () {
		let $timeline = $(this);
		let $children = $timeline.find("ol > li > div");
		let childWidth =
			(timelineWidth - gap * ($children.length - 1)) / $children.length;

		$children.animate({ width: childWidth + "px" }, 100);
	});

	$(".accordion-cell:not(:last-of-type)").click(function (e) {
		if ($(e.target).is("span") && $(this).hasClass("expanded")) {
			$(this).removeClass("expanded");
		} else {
			$(this).removeClass("collapsed");
			$(this).siblings().removeClass("expanded");
			$(this).addClass("expanded");
			$(this).siblings().addClass("collapsed");
		}
	});

	$(".timeline li > div").click(function () {
		$(".popup-overlay").toggleClass("visible");
		$(this).toggleClass("popup");
	});

	$(".popup-overlay").click(function () {
		$(this).toggleClass("visible");
		$(".timeline li > div").removeClass("popup");
		$(".popup-content").toggleClass("popup");
	});

	// Mobo version
	$(".tab").click(function () {
		var decade = $(this).data("decade");

		// Remove active class from all tabs and slider tracks
		$(".tab").removeClass("active");
		$(".slider__track").removeClass("active");

		// Add active class to the clicked tab and corresponding slider track
		$(this).addClass("active");
		$('.slider__track[data-decade="' + decade + '"]').addClass("active");
	});

	$(".slider__track__item").click(function () {
		const $item = $(this);
		const content = $item.html(); // Get the content of the clicked item

		console.log(content);

		// Populate the popup with the item's content
		$(".popup-content").html(content);
		$(".popup-content").toggleClass("popup");

		// Show the popup
		$(".popup-overlay").toggleClass("visible");
	});
});
